import * as Yup from "yup";
import { FormField } from "../../common/Form";
import Link from "../../common/Link";

export function loginFormFields(): Array<FormField> {
  return [
    {
      id: 'email',
      name: 'email',
      type: 'email',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci il tuo indirizzo email',
      validation: Yup.string()
        .email("Il campo deve essere un indirizzo email valido")
        .required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B"/>
        <path d="M9.17997 14.1721C9.46778 12.9041 10.6018 11.9575 11.9569 11.9575H29.0419C30.397 11.9575 31.531 12.9041 31.8188 14.1721L20.4994 21.0895L9.17997 14.1721ZM9.10938 15.7975V25.9111L17.3717 20.8467L9.10938 15.7975ZM18.7359 21.6804L9.38255 27.4136C9.8392 28.3766 10.8203 29.0425 11.9569 29.0425H29.0419C30.1785 29.0425 31.1596 28.3766 31.6162 27.4136L22.2628 21.6804L20.4994 22.758L18.7359 21.6804ZM23.6271 20.8467L31.8894 25.9111V15.7975L23.6271 20.8467Z" fill="#F9F9F9"/>
      </svg>
    },
    {
      id: 'password',
      name: 'password',
      type: 'password',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci la tua password',
      validation: Yup.string().required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B"/>
        <path d="M20.3906 11.3601C22.1579 11.3601 23.5906 12.4794 23.5906 13.8601V18.8601H17.1906V13.8601C17.1906 12.4794 18.6233 11.3601 20.3906 11.3601ZM25.1906 18.8601V13.8601C25.1906 11.789 23.0416 10.1101 20.3906 10.1101C17.7397 10.1101 15.5906 11.789 15.5906 13.8601V18.8601C13.8233 18.8601 12.3906 19.9794 12.3906 21.3601V27.6101C12.3906 28.9908 13.8233 30.1101 15.5906 30.1101H25.1906C26.9579 30.1101 28.3906 28.9908 28.3906 27.6101V21.3601C28.3906 19.9794 26.9579 18.8601 25.1906 18.8601Z" fill="#F9F9F9"/>
      </svg>
    },
    {
      id: 'recovery-password',
      name: 'recovery-password',
      type: 'custom',
      customElement: <div id="recovery-password-link" className="text-end">
        <Link href="/recupera-password">Password dimenticata?</Link>
      </div>
    },
    {
      id: 'remember_me',
      label: 'Ricordati',
      name: 'remember_me',
      type: 'radio',
      required: true,
    },
]}